<template>
    <div>

        <config-main-title>
            Zerodox Documentos / De-Paras
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir De-Para
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum De-Parq identificado.'" 
                icon="fas fa-equals"
                :action="'Incluir De-Para'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between hover-bg" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>

                        <span class="badge badge-secondary ml-2">#{{  dado.id_zerodox_doc_depara }}</span>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <span v-else>
                            <span class="badge badge-secondary" v-if="dado.st_record_id">
                                {{ dado.st_record_id }}
                            </span>
                        </span>
                    </span>
                </li>
            </div>
        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ ( item && item.id_zerodox_doc_depara ) ? '' : 'Novo' }}
                            De-Para
                            <span v-if="item && item.id_zerodox_doc_depara">
                                #{{ item.id_zerodox_doc_depara }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="form-row">
                            <div class="col col-12 col-md-9">
                                <az-input
                                    label="Título"
                                    :validate="validate"
                                    required
                                    v-model="item.st_titulo" />
                            </div>

                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Id Documento Zerodox"
                                    required
                                    :validate="validate"
                                    v-model="item.st_record_id" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input  
                                    label="Recepção Atendimento"
                                    type="autocomplete"
                                    optionsMode="aql"
                                    optionsDisplay="search"
                                    service="recepcaos.index"
                                    :optionsParm="{ filtros: true }"
                                    optionsName="recepcaos.apoiados"
                                    placeholder="Recepção..."
                                    v-model="item.recepcao" />
                            </div>

                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Anexar PDF Retornado no Tipo de Arquivo"
                                    type="select"
                                    placeholder="Padrão..."
                                    :validate="validate"
                                    service="tipo_arquivos.index"
                                    optionsData="id_tipo_arquivo"
                                    optionsMode="aql"
                                    v-model="item.id_tipo_arquivo" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Tipo"
                                    type="select"
                                    :optionsList="lista_modelos"
                                    optionsData="id"
                                    optionsDisplay="search"
                                    :validate="validate"
                                    required
                                    v-model="item.model_type" />
                            </div>

                            <div class="col col-12 col-md-6" v-if="item.model_type == 'App\\azure\\guia'">
                                <az-input
                                    label="Guia"
                                    type="select"
                                    :optionsList="lista_guia_tipos"
                                    optionsData="id"
                                    optionsDisplay="search"
                                    :validate="validate"
                                    required
                                    v-model="item.st_tipo_guia" />
                            </div>

                            <div class="col col-12 col-md-6" v-else-if="item.model_type && infoFiltroModel(item.model_type)">
                                <az-input
                                    label="Item"
                                    type="autocomplete" 
                                    optionsMode="aql"
                                    :optionsSync="!infoFiltroModel(item.model_type).nosync"
                                    :service="serviceFiltro(item.model_type)" 
                                    :optionsName="'filtro-' + item.model_type + infoFiltroModel(item.model_type).search"
                                    :optionsParm="{ ativos: true, agenda: true, recepcao: true, zerodox: true, ...infoFiltroModel(item.model_type).parms }"
                                    required 
                                    v-model="item.model" />
                            </div>
                        </div>

                        <!-- Filtros -->
                         <template v-if="item.model_type == 'App\\azure\\guia'">
                            <filtro-model class="my-3" v-model="item.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" />
                        </template>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="zerodoxDocDepara" :id="item.id_zerodox_doc_depara" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_zerodox_doc_depara ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <edicao-acessos ref="acessos" @refresh="load()" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import EdicaoAcessos from '../shared/EdicaoAcessos.vue';
import FiltroModel from '../shared/FiltroModel.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            outros_acessos: [],
            is_reembolso: false, 
            is_infusao: false, 
        }
    },

    props: ['teste'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        EdicaoAcessos,
        FiltroModel
    },

    computed: { 
        lista_opcoes_filtro: function () { 
            let opcoes = [                        
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                // {id:'tag-plano', search:'Classificação do Plano Particular', service: 'planos.index', tag: true},
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
            ];

            if ( this.$store.state.unidade.unidade_operacaos.length > 1 ) { 
                opcoes.push({id:'App\\azure\\unidadeOperacao', search:'Unidade', service:'unidade_operacaos.index'});
            }
            
            return opcoes;
        },

        lista_modelos: function () { 
            return [
                { id: 'App\\azure\\guia', search: 'Guia' },
                { id: 'App\\azure\\modeloDocumento', search: 'Modelo de Documento', service: "modelo_documentos.index" },
            ];
        },

        lista_guia_tipos: function () { 
            return [
                { id: 'C', search: 'Consulta' },
                { id: 'S', search: 'SP/SADT' },
                { id: 'H', search: 'Honorário Individual' },
                { id: 'R', search: 'Resumo de Internação' },
            ];
        },

        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

        tem_acesso: function () { 
            return 'tarefa_prioridade' == 'atendimento'
                || 'tarefa_prioridade' == 'receita';
        },

    },

    methods: { 
        serviceFiltro(model) { 
            let opcao = this.infoFiltroModel(model);
            return opcao ? opcao.service : null;
        },

        infoFiltroModel(model) { 
            if ( !this.lista_modelos || !model ) 
                return null;

            let opcao = this.lista_modelos.find(item => item.id == model);

            return opcao;
        },

        acessos(item, outro) { 
          this.$refs.acessos.abrir(
              'App\\azure\\tarefaPrioridade', 
              item.id_prioridade, 
              _.get(outro, 'search'), 
              _.get(outro, 'id')
            );
        },

        incluir () { 
            this.validate = false;

            let item = {
                id_zerodox_doc_depara: null, 
                st_titulo: "", 
                fl_ativo: true, 
                st_observacoes: "", 
                model_type: "App\\azure\\guia", 
                model_id: null,
                model: null, 
                id_recepcao: null, 
                st_record_id: null, 
                st_tipo_guia: null, 
                filtros: [], 
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service:'zerodox_doc_deparas',
                func: 'index',
                parms: { 
                    cadastro: true, 
                }
            });
        },
        editar (item) { 
            this.validate = false;

            this.item = _.cloneDeep (item);

            $('#edicaoModal').modal('show');
        },
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'zerodox_doc_deparas',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'zerodox_doc_deparas',
                dados: item,
            });

        },
    },

    mounted () { 
        this.breadcrumb = [
            { name: "Configurações", path: "/cadastros"},
            { name: "Zerodox Documento De-Paras" },
        ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.load();

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>